import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { Evento } from '../api/types';
import { useEvento } from '../reducers';
import { chunk } from '../utils'
import { sponsors, simil_header_style, locandina_casio, allenamenti_scolastici, dataToAnnoScolastico } from '../globals'
import { FotoContributor } from '../components';

const get_division_from_window_size = () => {
  const horiz = (window.innerWidth > window.innerHeight);
  return {
    divisione_contributors: horiz ? 4 : 2,
    divisione_allenamenti: horiz ? 3 : 1,
    size_allenamenti: horiz ? 8 : 40,
    size_contributor: horiz ? 8 : 20,
  }
}

const check_horizontal = (setHoriz: (_: boolean) => void) => {
  const horiz = (window.innerWidth > window.innerHeight);
  setHoriz(horiz)
}

const valid_date = (date: string | null | undefined) => {
  if (!date) return null;
  const parsed = new Date(date);
  if (isNaN(parsed.getTime())) return null;
  parsed.setHours(23, 59, 59, 999);
  return parsed;
}

const add_days = (date: Date, days: number) => {
  const shifted = new Date(date);
  shifted.setDate(shifted.getDate() + days);
  return shifted;
}

const sort_by_start_date = (ev1: Evento, ev2: Evento) => {
  return (valid_date(ev1.inizio)?.getTime() || 0) - (valid_date(ev2.inizio)?.getTime() || 0);
}

const get_edition_events = (eventi: Evento[], anno: number) => {
  return eventi
    .filter(ev => ev.tipologia === "o" && valid_date(ev.inizio) && dataToAnnoScolastico(new Date(ev.inizio)) === anno)
    .sort(sort_by_start_date);
}

const get_homepage_year = (today: Date) => dataToAnnoScolastico(today);

const is_waiting_for_next_edition = (today: Date, current_edition_events: Evento[]) => {
  const month = today.getMonth();
  return month >= 8 && month <= 10 && current_edition_events.length === 0;
}

const HomepageEditionStatus = ({ eventi }: { eventi: Evento[] }) => {
  const today = new Date();
  const anno = get_homepage_year(today);
  const current_edition_events = get_edition_events(eventi, anno);
  const qualifica = current_edition_events.find(ev => ev.tipologia_olifis === "qo");
  const finale = current_edition_events.find(ev => ev.tipologia_olifis === "fn");
  const qualifica_start = valid_date(qualifica?.inizio);
  const qualifica_registration_end = valid_date(qualifica?.fine_iscrizioni);
  const qualifica_registration_start = valid_date(qualifica?.inizio_iscrizioni);
  const finale_start = valid_date(finale?.inizio);
  const finale_status_end = finale_start ? add_days(finale_start, 2) : null;



  if (qualifica && qualifica_start && qualifica_registration_start && today.getTime() < qualifica_registration_start.getTime()) {
    return (
      <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        {/* @ts-ignore */}
        <div className="container py-4" align="center">
          <div style={{ ...simil_header_style }}>{"Le iscrizioni per l'edizione "}{anno}{" apriranno a breve!"}</div>
          <p style={{ textAlign: "center" }}>
            {"I preparativi per l'edizione "}{anno}{" sono in corso, consultate il calendario sulla "}<Link to={`/eventi/anno/${anno}/`}>pagina degli eventi</Link>{"! Ci sono delle novità importanti riguardo la gara di qualifica, vi consigliamo di visitare la pagina con il "}<Link to="/regolamento/">regolamento</Link>.
          </p>
        </div>
      </div>
    );
  }


  if (qualifica && qualifica_start && qualifica_registration_end && today.getTime() < qualifica_registration_end.getTime()) {
    return (
      <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        {/* @ts-ignore */}
        <div className="container py-4" align="center">
          <div style={{ ...simil_header_style }}>{"Le iscrizioni per l'edizione "}{anno}{" sono aperte!"}</div>
          <p style={{ textAlign: "center" }}>
            {"I preparativi per l'edizione "}{anno}{" sono stati completati, le iscrizioni sono aperte! Ci sono delle novità importanti riguardo la gara di qualifica, vi consigliamo di visitare la pagina con il "}<Link to="/regolamento/">regolamento</Link>.
          </p>
        </div>
      </div>
    );
  }

  if (qualifica && qualifica_start && today.getTime() < qualifica_start.getTime()) {
    return (
      <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        {/* @ts-ignore */}
        <div className="container py-4" align="center">
          <div style={{ ...simil_header_style }}>{"Le iscrizioni sono chiuse"}</div>
          <p style={{ textAlign: "center" }}>
            {"Le iscrizioni per l'edizione "}{anno}{" sono chiuse: ora aspettiamo la gara di qualifica. Puoi consultare la "}<Link to={`/eventi/anno/${anno}/`}>pagina degli eventi</Link>{" per date, orari e dettagli organizzativi."}
          </p>
        </div>
      </div>
    );
  }

  if (finale && finale_start && today.getTime() < finale_start.getTime()) {
    return (
      <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        {/* @ts-ignore */}
        <div className="container py-4" align="center">
          <div style={{ ...simil_header_style }}>{"Aspettando la Finale Nazionale "}{anno}</div>
          <p style={{ textAlign: "center" }}>
            {"La gara di qualifica si è conclusa: grazie a tutte le squadre partecipanti! Ora ci prepariamo alla Finale Nazionale. Puoi trovare le informazioni aggiornate nella "}<Link to={`/eventi/anno/${anno}/`}>pagina degli eventi</Link>.
            {finale.youtube_link &&
              <>
                <br />
                <br />
                La diretta streaming della Finale Nazionale sarà disponibile su <a href={finale.youtube_link}>YouTube</a>.
              </>
            }
          </p>
        </div>
      </div>
    );
  }

  if (finale && finale_start && finale_status_end && today.getTime() >= finale_start.getTime() && today.getTime() <= finale_status_end.getTime()) {
    return (
      <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        {/* @ts-ignore */}
        <div className="container py-4" align="center">
          <div style={{ ...simil_header_style }}>{"Finale Nazionale "}{anno}</div>
          <p style={{ textAlign: "center" }}>
            {"La Finale Nazionale è in corso. Puoi seguire tutte le informazioni aggiornate nella "}<Link to={`/eventi/anno/${anno}/`}>pagina degli eventi</Link>.
            {finale.youtube_link &&
              <>
                <br />
                <br />
                La diretta streaming è disponibile su <a href={finale.youtube_link}>YouTube</a>.
              </>
            }
          </p>
        </div>
      </div>
    );
  }

  if (finale && finale_status_end && today.getTime() > finale_status_end.getTime()) {
    return (
      <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        {/* @ts-ignore */}
        <div className="container py-4" align="center">
          <div style={{ ...simil_header_style }}>{"Ci vediamo alla prossima edizione!"}</div>
          <p style={{ textAlign: "center" }}>
            {"Si è conclusa la Finale Nazionale dell'edizione "}{anno}{": grazie a tutte le squadre, ai docenti e ai volontari che hanno partecipato. Vi aspettiamo alla prossima edizione!"}
            {finale.pagina_dedicata &&
              <>
                <br />
                <br />
                {"È disponibile anche una "}<a href={finale.pagina_dedicata}>pagina dedicata</a>{" all'evento."}
              </>
            }
          </p>
        </div>
      </div>
    );
  }

  if (qualifica && qualifica_start && today.getTime() >= qualifica_start.getTime()) {
    return (
      <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        {/* @ts-ignore */}
        <div className="container py-4" align="center">
          <div style={{ ...simil_header_style }}>{"Verso la Finale Nazionale "}{anno}</div>
          <p style={{ textAlign: "center" }}>
            {"La gara di qualifica si è conclusa: grazie a tutte le squadre partecipanti! Pubblicheremo le informazioni sulla Finale Nazionale appena saranno disponibili. Puoi seguire gli aggiornamenti nella "}<Link to={`/eventi/anno/${anno}/`}>pagina degli eventi</Link>.
          </p>
        </div>
      </div>
    );
  }

  if (is_waiting_for_next_edition(today, current_edition_events)) {
    return (
      <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        {/* @ts-ignore */}
        <div className="container py-4" align="center">
          <div style={{ ...simil_header_style }}>{"L'edizione "}{anno}{" sta per iniziare"}</div>
          <p style={{ textAlign: "center" }}>
            {"Stiamo preparando il calendario della nuova edizione della Gara a Squadre di Fisica. Torna su questo sito nelle prossime settimane: pubblicheremo qui date, regolamento aggiornato e modalità di iscrizione appena saranno disponibili."}
          </p>
        </div>
      </div>
    );
  }

  if (current_edition_events.length > 0) {
    return (
      <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        {/* @ts-ignore */}
        <div className="container py-4" align="center">
          <div style={{ ...simil_header_style }}>{"L'edizione "}{anno}{" è in preparazione"}</div>
          <p style={{ textAlign: "center" }}>
            {"I primi eventi ufficiali sono stati pubblicati. Stiamo completando le informazioni per la nuova edizione: puoi trovare date e dettagli nella "}<Link to={`/eventi/anno/${anno}/`}>pagina degli eventi</Link>.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
      {/* @ts-ignore */}
      <div className="container py-4" align="center">
        <div style={{ ...simil_header_style }}>Gara a Squadre di Fisica</div>
        <p style={{ textAlign: "center" }}>
          {"Stiamo aggiornando le informazioni sulla prossima edizione. Nel frattempo puoi consultare il "}<Link to="/regolamento/">regolamento</Link>{" o visitare la pagina dei "}<Link to="/eventi/">prossimi eventi</Link>{"."}
        </p>
      </div>
    </div>
  );
}

const HomepagePoli = ({ eventi }: { eventi: Evento[] }) => {
  const today = new Date();
  const anno = get_homepage_year(today);
  const qualifica = get_edition_events(eventi, anno).find(ev => ev.tipologia_olifis === "qo");
  if (!qualifica) return null;
  const qualifica_start = valid_date(qualifica.inizio);
  if (qualifica_start && today.getTime() >= qualifica_start.getTime()) return null;

  return (
    <div style={{ backgroundColor: 'rgba(255, 255, 255, 1.0)', minHeight: "200px" }} >
      {/* @ts-ignore*/}
      <div className="container py-4" align="center">
        <div style={{ ...simil_header_style }}>{"Poli per l'edizione "}{anno}</div>
        <p style={{ textAlign: "center" }}>{"Stiamo gestendo l'organizzazione dei poli locali per la qualifica del "}{anno}{". Visita la "}<Link to={`/lista-poli/${qualifica.id}/`}>seguente pagina</Link>{" per avere la lista di poli che hanno aderito. Verrà aggiornata dopo la scadenza per la proposta di un polo."}</p>
      </div>
    </div>
  );
}

const Home = (props: {}) => {
  // Lo lasciamo qua volontariamente così preloadi gli eventi.
  const eventi = useEvento(props);
  const [horiz, setHoriz] = useState(window.innerWidth > window.innerHeight);
  const { divisione_contributors, divisione_allenamenti, size_allenamenti } = get_division_from_window_size();
  const horiz_size = horiz ? '400px' : '200px';
  const homepage_year = get_homepage_year(new Date());
  const location = useLocation();
  const navigate = useNavigate();
  if (location.hash == "#/about-us/") {
    navigate("/about-us/")
  }

  useEffect(() => {
    document.title = "Gara a Squadre di fisica";
    window.addEventListener('resize', () => check_horizontal(setHoriz));
  }, [])

  return (
    <div className="main-container mb-5">
      <div style={{ width: '100%' }}>
        <div id="homepage-image-first">
          <div style={{ zIndex: 10 }} className="container">
            <img src="/static/gascal/images/gas.png" style={{ maxWidth: horiz_size }} />
            <p className="px-2 text-center">
              Benvenuto sulla pagina della Gara a Squadre di Fisica, parte del <a href="https://olifis.it/">Progetto OLIFIS </a>{"dell'"}<a href="https://aif.it/">AIF</a> per studenti delle scuole secondarie superiori.
            </p>
          </div>
        </div>

        <div style={{ backgroundColor: 'rgba(255, 255, 255, 1.0)' }}>
          <div className="container py-5">
            <div style={simil_header_style}><Link to="/sponsor/">Sponsor</Link></div>
            {chunk(sponsors, divisione_contributors).map((chunk, idx1) =>
              <div className="flex-row" key={idx1}>
                {chunk.map((sponsor, idx2) =>
                  <div className="bannerino flex-grow-1" key={idx2} style={{ flexBasis: '100%' }}>
                    <a href={sponsor.website}>
                      <img
                        src={sponsor.logo_url}
                        className="img-thumbnail"
                        alt={sponsor.name}
                        style={{ borderStyle: 'none', maxHeight: '200px' }}
                      />
                    </a>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <HomepageEditionStatus eventi={eventi} />

        <HomepagePoli eventi={eventi} />

        <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
          {/* @ts-ignore */}
          <div className="container py-4" align="center">
            <div style={{ ...simil_header_style }}>La gara a squadre di Fisica</div>
            <p style={{ textAlign: 'center' }}>
              In questo video realizzato in collaborazione con il nostro partner Casio presentiamo la Gara a Squadre di Fisica, con qualche dettaglio sullo svolgimento della Finale Nazionale 2024. Il secondo video include la telecronaca integrale della Finale. C'è inoltre una <a href="/finale-nazionale/2024/">pagina dedicata</a> all'evento.
            </p>


            <iframe
              width="560" height="315" title="YouTube video player"
              frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen
              src="https://www.youtube.com/embed/mUUnaJXMuRE?si=-Fk4_KSMtvc8qAfr" style={{ display: "block", maxWidth: "100%" }}
            >
            </iframe>
          </div>
        </div>


        <div style={{ backgroundColor: 'rgba(255, 255, 255, 1.0)' }} id="homepage-chi-siamo">
          <div className="container py-4">
            <div style={{ ...simil_header_style }}>Chi siamo</div>
            <p style={{ textAlign: 'center' }}>
              La competizione è organizzata da studenti universitari volontari, principalmente della <a href="https://www.sns.it/">Scuola Normale Superiore</a>. Puoi trovare informazioni aggiuntive sulla pagina <Link to={"/about-us/"}>Chi siamo</Link>.
              <br />
              <br />
              <div style={{ ...simil_header_style, fontSize: "2.6em" }}>Collaboratori esterni</div>
              {"Ci teniamo inoltre a ringraziare sentitamente alcuni docenti volontari che hanno collaborato con noi in più edizioni per organizzare un Allenamento Scolastico. Il loro contributo è stato fondamentale per la buona riuscita dell'iniziativa"}
              <br />
              Anche tu puoi fare parte di questa lista! Puoi contattarci a <a href="mailto:gas@olifis.it">gas@olifis.it</a> proponendo un testo da sottoporre come allenamento a tutta Italia. I dettagli della procedura sono spiegati nel <Link to="/regolamento/">regolamento</Link>.
            </p>
            <div>
              {chunk(allenamenti_scolastici.filter(part => part.homepage), divisione_allenamenti).map((item, idx1) =>
                <div className="flex-row" key={idx1}>
                  {item.map((iitem, idx2) =>
                    <FotoContributor
                      {...iitem}
                      size={size_allenamenti} class_name="foto-propositore-problemi"
                      key={idx2}
                      showAffiliazione={true}
                    />)}
                </div>
              )}
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }} >
          <br />
          <div className="container py-4">
            <div style={simil_header_style}>Regolamento</div>
            <div className="flex-row">
              <div className="text-row">
                Possono partecipare squadre di studenti delle scuole secondarie superiori, fino a 5 componenti. I componenti di ogni squadra collaborano per risolvere problemi di Fisica a risposta numerica. La classifica viene aggiornata in tempo reale ed è visibile a tutti. Puoi consultare il <Link to="/regolamento/">regolamento esteso</Link> o andare a visitare la pagina dei <Link to="/eventi/">prossimi eventi</Link>.
              </div>
            </div>
          </div>
          <br />
          <br />
        </div>

        <div style={{ backgroundColor: 'rgba(255, 255, 255, 1.0)' }}>
          <div className="container py-4">
            <div style={simil_header_style}>Eventi di formazione</div>
            <p>
              CASIO ha supportato le squadre iscritte alla prima
              edizione del campionato con l’utilizzo della calcolatrice
              grafica senza CAS con tre momenti di formazione gratuita
              online, diretta ai docenti e agli studenti sulle tematiche più
              vicine a quelle che normalmente vengono affrontate durante
              le gare approcciate con la calcolatrice grafica.

              <br />
              Durante il {homepage_year} saranno presenti altri eventi di formazione, sempre sotto forma di webinar, in cui si mostrerà anche la soluzione
              ad alcuni dei problemi proposti nelle edizioni precedenti.
            </p>

            <table className="table table-responsive table-striped table-hover">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">Data e ora</th>
                  <th scope="col">Argomento</th>
                  <th scope="col">Link</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td scope="row"></td>
                  <td>Sono previsti 3 eventi: uno di presentazione della nuova edizione e 2 di formazione.</td>
                  <td></td>
                </tr>

                <tr>
                  <td scope="row">
                    13/11/2026 16:00-17:00
                  </td>
                  <td>
                    Presentazione di GaS
                    <br />
                    {"Intervengono: Fabio Zoratti responsabile nazionale del progetto, Prof.ssa Cristina Arienti, Stefano Pasquali, finalista GaS 2027 e medaglia d'argento alle International Physics Olympiad (IPhO) 2027 e Federico Roccaforte, argento alle European Physics Olympiad (EuPhO)."}
                  </td>
                  <td>
                    <a className="ml-2 btn btn-info" href="https://www.youtube.com/watch?v=gljqD24A6bk">Studenti</a>
                    <a className="ml-2 btn btn-info" href="https://www.casio-edu.it/webinar/aif-e-casio-presentano-la-gara-a-squadre-di-fisica-2027/917/">Docenti</a>
                  </td>
                </tr>
                <tr>
                  <td scope="row">09/02/2027 16:00-17:00</td>
                  <td>
                    {"Incontro generale sull'uso della calcolatrice"}
                    <br />
                    Relatore: Prof.ssa Cristina Arienti</td>
                  <td>
                    <a className="ml-2 btn btn-info" href="https://www.youtube.com/watch?v=LCAgY16RR7Q">Studenti</a>
                    <a className="ml-2 btn btn-info" href="https://www.casio-edu.it/webinar/campionati-di-fisica-2027-incontro-generale-sulluso-della-calcolatrice-grafica/919/">Docenti</a>
                  </td>
                </tr>
                <tr>
                  <td scope="row">16/02/2027 16:00-17:00</td>
                  <td>
                    Come risolvere alcuni problemi con la calcolatrice grafica
                    <br />
                    Relatore: Prof.ssa Cristina Arienti
                  </td>
                  <td>
                    <a className="ml-2 btn btn-info" href="https://www.youtube.com/watch?v=Jw35pJfkZ_4">Studenti</a>
                    <a className="ml-2 btn btn-info" href="https://www.casio-edu.it/webinar/campionati-di-fisica-2027-come-risolvere-alcuni-problemi-con-la-calcolatrice-graficaenbsp/920/">Docenti</a>
                  </td>
                </tr>
              </tbody>
            </table>

            <p>
              Tutti gli incontri saranno tenuti utilizzando la calcolatrice grafica FX-CG50.
              Chi desidera può scaricare il software emulatore gratuito:<a className="ml-2 btn btn-info" href="https://edu.casio.com/softwarelicense/index.php">Studenti</a><a className="btn btn-info" href="https://www.casio-edu.it/software/emulatori/licenze-gratuite-docenti/">Docenti</a>
            </p>
            <div className="row justify-content-center">
              <iframe style={{ width: '600px', height: '600px' }} src={locandina_casio}></iframe>
            </div>

          </div>
        </div>
        <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
          <br />
          <div className="container py-4">
            <div style={simil_header_style}>Calendario finale nazionale 2027</div>
            <table className="table table-responsive table-striped table-hover">
              <thead className="thead-dark">
                <tr>
                  <th></th>
                  <th scope="col">Mercoledì 7/4/2027</th>
                  <th scope="col">Giovedì 8/4/2027</th>
                  <th scope="col">Venerdì 9/4/2027</th>
                  <th scope="col">Sabato 10/4/2027</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Mattina</th>
                  <td></td>
                  <td>Gara sperimentale individuale</td>
                  <td>Gara teorica individuale</td>
                  <td><b>Cerimonia premiazione gara individuale</b></td>
                </tr>
                <tr>
                  <th scope="row">Pomeriggio</th>
                  <td>Arrivo partecipanti gara individuale</td>
                  <td><b>Arrivo partecipanti gara a squadre</b></td>
                  <td><b>Gara a squadre e premiazione</b></td>
                  <td><b>Partenza partecipanti</b></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div >
  );
};

export default Home;
